/* @generated from adl module ids.hotel */

import * as ADL from './../runtime/adl';
import * as common from './../common';
import * as common_strings from './../common/strings';

export enum AmenityLevel {
  property,
  room,
}

const AmenityLevel_AST : ADL.ScopedDecl =
  {"moduleName":"ids.hotel","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Amenity levels which represent the levels\nof amenities available at a hotel\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An amenity available to all guests at an hotel property\n"}],"serializedName":"property","default":{"kind":"nothing"},"name":"property","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An amenity available only to an associated room\n"}],"serializedName":"room","default":{"kind":"nothing"},"name":"room","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AmenityLevel","version":{"kind":"nothing"}}};

export const snAmenityLevel: ADL.ScopedName = {moduleName:"ids.hotel", name:"AmenityLevel"};

export function texprAmenityLevel(): ADL.ATypeExpr<AmenityLevel> {
  return {value : {typeRef : {kind: "reference", value : snAmenityLevel}, parameters : []}};
}

/**
 * Represents a property's check-in information
 */
export interface CheckInDetails {
  /**
   * The time at which the property begins to allow check-ins.
   */
  beginTime: common.LocalTime;
  /**
   * The time at which a property stops allowing check-ins.
   */
  endTime: (common.LocalTime|null);
  /**
   * Whether the property has 24-hour check-in. Default is false.
   */
  has24HourCheckIn: boolean;
  /**
   * The property's check-in policy, if present
   */
  instructions: (common_strings.StringNE|null);
  /**
   * Any special instructions for checking into this property that may be
   * be special to this property, if present
   */
  specialInstructions: (common_strings.StringNE|null);
  /**
   * The minimum age for a customer to be able to check-in at this property,
   * if present
   */
  minAge: (number|null);
}

export function makeCheckInDetails(
  input: {
    beginTime: common.LocalTime,
    endTime: (common.LocalTime|null),
    has24HourCheckIn?: boolean,
    instructions: (common_strings.StringNE|null),
    specialInstructions: (common_strings.StringNE|null),
    minAge: (number|null),
  }
): CheckInDetails {
  return {
    beginTime: input.beginTime,
    endTime: input.endTime,
    has24HourCheckIn: input.has24HourCheckIn === undefined ? false : input.has24HourCheckIn,
    instructions: input.instructions,
    specialInstructions: input.specialInstructions,
    minAge: input.minAge,
  };
}

const CheckInDetails_AST : ADL.ScopedDecl =
  {"moduleName":"ids.hotel","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a property's check-in information\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The time at which the property begins to allow check-ins.\n"}],"serializedName":"beginTime","default":{"kind":"nothing"},"name":"beginTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The time at which a property stops allowing check-ins.\n"}],"serializedName":"endTime","default":{"kind":"nothing"},"name":"endTime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether the property has 24-hour check-in. Default is false.\n"}],"serializedName":"has24HourCheckIn","default":{"kind":"just","value":false},"name":"has24HourCheckIn","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's check-in policy, if present\n"}],"serializedName":"instructions","default":{"kind":"nothing"},"name":"instructions","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Any special instructions for checking into this property that may be\nbe special to this property, if present\n"}],"serializedName":"specialInstructions","default":{"kind":"nothing"},"name":"specialInstructions","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The minimum age for a customer to be able to check-in at this property,\nif present\n"}],"serializedName":"minAge","default":{"kind":"nothing"},"name":"minAge","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}]}}]}},"name":"CheckInDetails","version":{"kind":"nothing"}}};

export const snCheckInDetails: ADL.ScopedName = {moduleName:"ids.hotel", name:"CheckInDetails"};

export function texprCheckInDetails(): ADL.ATypeExpr<CheckInDetails> {
  return {value : {typeRef : {kind: "reference", value : snCheckInDetails}, parameters : []}};
}

/**
 * An area represented in square metres
 */
export type AreaSqM = number;

const AreaSqM_AST : ADL.ScopedDecl =
  {"moduleName":"ids.hotel","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An area represented in square metres\n"}],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}},"name":"AreaSqM","version":{"kind":"nothing"}}};

export const snAreaSqM: ADL.ScopedName = {moduleName:"ids.hotel", name:"AreaSqM"};

export function texprAreaSqM(): ADL.ATypeExpr<AreaSqM> {
  return {value : {typeRef : {kind: "reference", value : snAreaSqM}, parameters : []}};
}

/**
 * Represents occupancy information of a hotel room
 */
export interface Occupancy {
  /**
   * The total maximum occupancy allowed
   */
  total: number;
  /**
   * Maximum number of children allowed
   */
  children: number;
  /**
   * Maximum number of adults allowed
   */
  adults: number;
}

export function makeOccupancy(
  input: {
    total: number,
    children?: number,
    adults?: number,
  }
): Occupancy {
  return {
    total: input.total,
    children: input.children === undefined ? 0 : input.children,
    adults: input.adults === undefined ? 0 : input.adults,
  };
}

const Occupancy_AST : ADL.ScopedDecl =
  {"moduleName":"ids.hotel","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents occupancy information of a hotel room\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The total maximum occupancy allowed\n"}],"serializedName":"total","default":{"kind":"nothing"},"name":"total","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Maximum number of children allowed\n"}],"serializedName":"children","default":{"kind":"just","value":0},"name":"children","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Maximum number of adults allowed\n"}],"serializedName":"adults","default":{"kind":"just","value":0},"name":"adults","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}}]}},"name":"Occupancy","version":{"kind":"nothing"}}};

export const snOccupancy: ADL.ScopedName = {moduleName:"ids.hotel", name:"Occupancy"};

export function texprOccupancy(): ADL.ATypeExpr<Occupancy> {
  return {value : {typeRef : {kind: "reference", value : snOccupancy}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ids.hotel.AmenityLevel" : AmenityLevel_AST,
  "ids.hotel.CheckInDetails" : CheckInDetails_AST,
  "ids.hotel.AreaSqM" : AreaSqM_AST,
  "ids.hotel.Occupancy" : Occupancy_AST
};
